import { endpoint } from "~/api";
import { ICreateDspConnectionTypePayload, IDspConnectionType, IUpdateDspConnectionTypePayload } from "~/modules/Dictionary/models/DspConnectionType";
import { IExternalBuyer, IExternalBuyerPayload } from "~/modules/Dictionary/models/ExternalBuyer";
import {
  IExternalBuyerP2P,
  IExternalBuyerP2PPayload,
  IExternalBuyerP2PUploadResult,
} from "~/modules/Dictionary/models/ExternalBuyerP2P";
import { ICreatePresetPayload, IPreset, IUpdatePresetPayload, PresetSide } from "~/modules/Dictionary/models/Preset";

export const fetchDspConnectionTypes = () =>
  endpoint.get<IDspConnectionType[]>("/dsp-connection-types").then((r) => r.data);

export const createDspConnectionType = (payload: ICreateDspConnectionTypePayload) =>
  endpoint.post<IDspConnectionType>("/dsp-connection-types", payload).then((r) => r.data);

export const updateDspConnectionType = (id: number, payload: IUpdateDspConnectionTypePayload) =>
  endpoint.patch<IDspConnectionType>(`/dsp-connection-types/${id}`, payload).then((r) => r.data);

export const deleteDspConnectionType = (id: number) => endpoint.delete(`/dsp-connection-types/${id}`).then(() => undefined);

export const fetchExternalBuyers = () =>
  endpoint.get<IExternalBuyer[]>("/external-buyers").then((r) => r.data);

export const createExternalBuyer = (payload: IExternalBuyerPayload) =>
  endpoint.post<IExternalBuyer>("/external-buyers", payload).then((r) => r.data);

export const updateExternalBuyer = (id: number, payload: IExternalBuyerPayload) =>
  endpoint.put<IExternalBuyer>(`/external-buyers/${id}`, payload).then((r) => r.data);

export const deleteExternalBuyer = (id: number) => endpoint.delete(`/external-buyers/${id}`).then(() => undefined);

export const fetchExternalBuyersP2P = () =>
  endpoint.get<IExternalBuyerP2P[]>("/external-buyers-p2p").then((r) => r.data);

export const createExternalBuyerP2P = (payload: IExternalBuyerP2PPayload) =>
  endpoint.post<IExternalBuyerP2P>("/external-buyers-p2p", payload).then((r) => r.data);

export const updateExternalBuyerP2P = (id: number, payload: IExternalBuyerP2PPayload) =>
  endpoint.put<IExternalBuyerP2P>(`/external-buyers-p2p/${id}`, payload).then((r) => r.data);

export const deleteExternalBuyerP2P = (id: number) =>
  endpoint.delete(`/external-buyers-p2p/${id}`).then(() => undefined);

export const fetchPresets = () => endpoint.get<{ items: IPreset[] }>("/presets").then((r) => r.data.items);

export const createPreset = (payload: ICreatePresetPayload) =>
  endpoint.post<IPreset>("/presets", payload).then((r) => r.data);

export const updatePreset = (side: PresetSide, id: number, payload: IUpdatePresetPayload) =>
  endpoint.patch<IPreset>(`/presets/${side}/${id}`, payload).then((r) => r.data);

export const deletePreset = (side: PresetSide, id: number) =>
  endpoint.delete(`/presets/${side}/${id}`).then(() => undefined);

export const uploadExternalBuyerP2P = (file: File, dspConnectionType: string) => {
  const data = new FormData();
  data.append("file", file);
  return endpoint
    .post<IExternalBuyerP2PUploadResult>("/external-buyers-p2p/upload", data, {
      params: { dspConnectionType },
    })
    .then((r) => r.data);
};
